import { track } from "../lib/analytics";
import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = JSON.parse(localStorage.getItem("stuff_cart")) || [];
      return raw.map((i) => ({ ...i, key: i.key || i.product_id }));
    } catch { return []; }
  });
  const [vendor, setVendor] = useState(() => {
    try { return JSON.parse(localStorage.getItem("stuff_cart_vendor")) || null; } catch { return null; }
  });

  useEffect(() => {
    localStorage.setItem("stuff_cart", JSON.stringify(items));
    localStorage.setItem("stuff_cart_vendor", JSON.stringify(vendor));
  }, [items, vendor]);

  const addItem = (product, vendorInfo) => {
    if (product.in_stock === false || (product.quantity != null && Number(product.quantity) <= 0)) return false; // rupture : jamais au panier
    const tier = product.selectedTier || null;
    const key = tier ? `${product.id}::${tier.label}` : product.id;
    const entry = { key, product_id: product.id, name: tier ? `${product.name} · ${tier.label}` : product.name, price: tier ? tier.price : product.price, qty: 1, image_url: product.image_url, tier: tier?.label || null };
    track("add_to_cart", { meta: { product: product.name, vendor: vendorInfo?.name || "" } });
    // cart is bound to a single vendor; switching vendor resets cart
    if (vendor && vendor.id !== vendorInfo.id) {
      if (!window.confirm("Ton panier contient des produits d'un autre vendeur. Le vider ?")) return false;
      setItems([entry]);
      setVendor(vendorInfo);
      return true;
    }
    setVendor(vendorInfo);
    setItems((prev) => {
      const found = prev.find((i) => (i.key || i.product_id) === key);
      if (found) return prev.map((i) => (i.key || i.product_id) === key ? { ...i, qty: i.qty + 1 } : i);
      return [...prev, entry];
    });
    return true;
  };

  const setQty = (key, qty) => {
    if (qty <= 0) { removeItem(key); return; }
    setItems((prev) => prev.map((i) => (i.key || i.product_id) === key ? { ...i, qty } : i));
  };

  const removeItem = (key) => {
    setItems((prev) => {
      const next = prev.filter((i) => (i.key || i.product_id) !== key);
      if (next.length === 0) setVendor(null);
      return next;
    });
  };

  const clear = () => { setItems([]); setVendor(null); };

  const count = items.reduce((s, i) => s + i.qty, 0);
  const total = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, vendor, addItem, setQty, removeItem, clear, count, total }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
